import sagaManager from '../../sagaManager';
import * as shadeXRmActions from './shadeXRmActions';
import sagas from './shadeXRmSagas';
import * as shadeXRmTypes from './shadeXRmTypes';

sagaManager.addSagaToRoot(sagas);

export { shadeXRmActions, shadeXRmTypes };
